import {Component, ViewChild} from '@angular/core';

import {BoiteDialogueLogComponent} from '../../../../../../val-ammon-composants/val-traitements-lib/src/public-api';
import {AeFSynchroniserCyclesViesFacturesAchatParametres, EFactTraitementService} from '../../../../../../val-ammon-services/val-services-efact-lib/src/public-api';

//Traitement de synchronisation des cycles de vies des factures d’achat
@Component (
{
  selector: 'val-synchroniser-cycles-vies-factures-achat',
  imports: 
  [
    BoiteDialogueLogComponent
  ],
  templateUrl: './synchroniser-cycles-vies-factures-achat.component.html',
  styleUrl: './synchroniser-cycles-vies-factures-achat.component.scss',
})
export class SynchroniserCyclesViesFacturesAchatComponent 
{
  //Création
  //  Paramètres
  //    eFactTraitementService: Service e-Facture
  constructor (private eFactTraitementService: EFactTraitementService) 
  {
  }
  
  //Boîte de dialogue log
  @ViewChild ("boiteDialogueLog")
  public boiteDialogueLog!: BoiteDialogueLogComponent;

  //Exécute le traitement
  //  Paramètres
  //    identifiantsFactures : Identifiants des factures
  public async Executer (identifiantsFactures: string[]) : Promise<void> 
  {
    let operation: Promise<void>;
    let aefSynchroniserCyclesViesFacturesAchatParametres: AeFSynchroniserCyclesViesFacturesAchatParametres;

    operation = new Promise<void> (async (fonctionRetour) =>
    {
      try
      {
        aefSynchroniserCyclesViesFacturesAchatParametres = new AeFSynchroniserCyclesViesFacturesAchatParametres ();
        aefSynchroniserCyclesViesFacturesAchatParametres.identifiantSession = crypto.randomUUID ();
        aefSynchroniserCyclesViesFacturesAchatParametres.identifiantsFactures = identifiantsFactures;

        this.boiteDialogueLog.Executer (aefSynchroniserCyclesViesFacturesAchatParametres.identifiantSession);

        await this.eFactTraitementService.SynchroniserCyclesViesFacturesAchat (aefSynchroniserCyclesViesFacturesAchatParametres);

        await this.boiteDialogueLog.AttendreFermeture ();
      }
      catch (erreur)
      {
      }

      fonctionRetour ();
    });

    return operation;
  }
}
